import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const BannersCarousel = () => {
    const [banners, setBanners] = useState([]);
    const [current, setCurrent] = useState(0);
    const timerRef = useRef(null);

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/banners`)
            .then(res => {
                if (res.data.success && res.data.banners?.length) {
                    setBanners(res.data.banners);
                }
            })
            .catch(() => {});
    }, []);

    useEffect(() => {
        if (banners.length <= 1) return;
        timerRef.current = setInterval(() => {
            setCurrent(prev => (prev + 1) % banners.length);
        }, 5000);
        return () => {
            if (timerRef.current) clearInterval(timerRef.current);
        };
    }, [banners.length, current]);

    const goTo = (index) => {
        if (timerRef.current) {
            clearInterval(timerRef.current);
            timerRef.current = null;
        }
        setCurrent(index);
    };

    const goPrev = () => goTo((current - 1 + banners.length) % banners.length);
    const goNext = () => goTo((current + 1) % banners.length);

    if (banners.length === 0) return null;

    const currentBanner = banners[current];

    return (
        <section className="homeBannersSection">
            <div className="homeBannersWrapper">
                <div className="homeBannerSlide">
                    {currentBanner.link ? (
                        <a
                            href={currentBanner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="homeBannerLink"
                        >
                            <img key={currentBanner._id} src={currentBanner.image} alt="Promotional banner" />
                        </a>
                    ) : (
                        <img key={currentBanner._id} src={currentBanner.image} alt="Promotional banner" />
                    )}
                </div>
                {banners.length > 1 && (
                    <>
                        <button type="button" className="homeBannerArrow prev" onClick={goPrev} aria-label="Previous">
                            <FaChevronLeft />
                        </button>
                        <button type="button" className="homeBannerArrow next" onClick={goNext} aria-label="Next">
                            <FaChevronRight />
                        </button>
                        <div className="homeBannerDots">
                            {banners.map((_, i) => (
                                <button
                                    key={i}
                                    type="button"
                                    className={`homeBannerDot ${i === current ? 'active' : ''}`}
                                    onClick={() => goTo(i)}
                                    aria-label={`Go to slide ${i + 1}`}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </section>
    );
};

export default BannersCarousel;
